<span class="row">
  <div class="col-md-6">
    <pr-image-viewer
      imageURL="assets/img/risk-chart.png"
      [open]="viewerOpen"
      (close)="viewerOpen = false"
    ></pr-image-viewer>
    <img
      (click)="viewerOpen = true"
      style="width: 100%"
      class="mb"
      src="assets/img/risk-chart.png"
    />
  </div>
</span>

<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="owners">
      <div class="row">
        @for (owner of owners.controls; track owner; let index = $index) {
          <ng-container [formGroup]="owner">
            <div class="col-md-{{ owners?.length > 1 ? 6 : 12 }}">
              <owner-header [owners]="owners" [index]="index"></owner-header>
              <ng-container formGroupName="riskProfil">
                <risk-profil-third-part
                  [derrors]="derrors"
                ></risk-profil-third-part>
              </ng-container>
            </div>
          </ng-container>
        }
      </div>
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
